<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">消息推送管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>消息通道</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="toolbar">
        <el-select
          v-model="filterChannelCode"
          class="filter-channel"
          size="small"
          clearable
          placeholder="筛选通道类型"
          @change="onFilterChannel"
        >
          <el-option
            v-for="t in kindOptions"
            :key="t.code"
            :label="t.labelZh"
            :value="t.code"
          />
        </el-select>
        <el-button type="primary" size="small" v-if="canChannelAdd" @click="openCreate">新增消息通道</el-button>
      </div>
      <el-table :data="rows" border size="small" style="width: 100%">
        <el-table-column label="序号" width="72">
          <template slot-scope="scope">
            {{ (page - 1) * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="channelLabelZh" label="通道名称" width="120" />
        <el-table-column prop="msgUse" label="用途说明" min-width="140" show-overflow-tooltip />
        <el-table-column prop="params" label="通道配置" min-width="220">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.params" placement="top">
              <span class="ellipsis">{{ scope.row.params }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="updater" label="更新人" width="120" />
        <el-table-column label="更新时间" width="160">
          <template slot-scope="scope">
            {{ formatMs(scope.row.updateTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="canChannelView" type="text" size="small" @click="openDetail(scope.row)">
              详情
            </el-button>
            <el-button v-if="canChannelEdit" type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button
              v-if="canChannelDelete"
              type="text"
              size="small"
              style="color:#f56c6c"
              @click="confirmDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="page"
        :page-sizes="[10, 20, 50]"
        @size-change="onSizeChange"
        @current-change="fetchList"
      />
    </el-card>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="640px"
      :close-on-click-modal="false"
      @closed="resetForm"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="formRules"
        label-width="140px"
        size="small"
        autocomplete="off"
        :disabled="isDetail"
      >
        <el-form-item label="通道名称" required>
          <el-select
            v-model="form.channelCode"
            placeholder="请选择"
            :disabled="isEdit"
            style="width: 100%"
          >
            <el-option v-for="t in kindOptions" :key="t.code" :label="t.labelZh" :value="t.code" />
          </el-select>
        </el-form-item>

        <template v-if="form.channelCode === 'AWS_EMAIL'">
          <el-form-item label="awsFrom"><el-input v-model="form.awsEmail.awsFrom" autocomplete="off" /></el-form-item>
          <el-form-item label="awsFromname"><el-input v-model="form.awsEmail.awsFromname" autocomplete="off" /></el-form-item>
          <el-form-item label="awsSmtpUsername">
            <el-input v-model="form.awsEmail.awsSmtpUsername" name="aws-ses-config-user" autocomplete="off" />
          </el-form-item>
          <el-form-item label="awsSmtpPassword">
            <el-input v-model="form.awsEmail.awsSmtpPassword" name="aws-ses-config-secret" autocomplete="off" />
          </el-form-item>
          <el-form-item label="awsHost"><el-input v-model="form.awsEmail.awsHost" autocomplete="off" /></el-form-item>
          <el-form-item label="awsPort"><el-input v-model="form.awsEmail.awsPort" autocomplete="off" /></el-form-item>
        </template>

        <template v-else-if="form.channelCode === 'LARK'">
          <el-form-item label="url" required><el-input v-model="form.lark.url" placeholder="webhook 基础 url" /></el-form-item>
          <el-form-item label="channelKey（可选）"><el-input v-model="form.lark.channelKey" /></el-form-item>
        </template>

        <template v-else-if="form.channelCode === 'MY_TASK'">
          <el-form-item label="url" required><el-input v-model="form.myTask.url" placeholder="webhook 完整或基础 url" /></el-form-item>
          <el-form-item label="channelKey（可选）"><el-input v-model="form.myTask.channelKey" /></el-form-item>
        </template>

        <template v-else-if="form.channelCode === 'SMS'">
          <el-form-item label="sourceType"><el-input v-model="form.sms.sourceType" /></el-form-item>
          <el-form-item label="user"><el-input v-model="form.sms.user" /></el-form-item>
          <el-form-item label="hash"><el-input v-model="form.sms.hash" /></el-form-item>
          <el-form-item label="url"><el-input v-model="form.sms.url" /></el-form-item>
          <el-form-item label="appKey"><el-input v-model="form.sms.appKey" /></el-form-item>
          <el-form-item label="secretKey"><el-input v-model="form.sms.secretKey" /></el-form-item>
          <el-form-item label="password"><el-input v-model="form.sms.password" /></el-form-item>
          <el-form-item label="account"><el-input v-model="form.sms.account" /></el-form-item>
        </template>

        <template v-else-if="form.channelCode === 'TELEGRAM'">
          <el-form-item label="token"><el-input v-model="form.telegram.token" /></el-form-item>
          <el-form-item label="chatId"><el-input v-model="form.telegram.chatId" /></el-form-item>
        </template>

        <template v-else-if="form.channelCode === 'JPUSH'">
          <el-form-item label="AppKey" prop="jpush.appKey" required>
            <el-input v-model.trim="form.jpush.appKey" autocomplete="off" placeholder="请输入极光应用 AppKey" />
          </el-form-item>
          <el-form-item label="Master Secret" prop="jpush.masterSecret" required>
            <el-input
              v-model.trim="form.jpush.masterSecret"
              type="password"
              show-password
              name="jpush-master-secret"
              autocomplete="new-password"
              placeholder="请输入极光应用 Master Secret"
            />
          </el-form-item>
        </template>

        <el-form-item label="用途说明">
          <el-input
            v-model="form.msgUse"
            type="textarea"
            :rows="2"
            maxlength="512"
            show-word-limit
            placeholder="选填。说明本条通道配置的用途/场景，便于运维区分"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ isDetail ? '关 闭' : '取 消' }}</el-button>
        <el-button v-if="!isDetail" type="primary" @click="confirmSubmit">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { hasPerm } from 'common/permission';
import api from './api';
import { MessageBox, Message } from 'element-ui';

function emptyForm() {
  return {
    id: null,
    channelCode: '',
    solidity: 0,
    awsEmail: {
      awsFrom: '',
      awsFromname: '',
      awsSmtpUsername: '',
      awsSmtpPassword: '',
      awsHost: '',
      awsPort: '',
    },
    lark: { url: '', channelKey: '' },
    myTask: { url: '', channelKey: '' },
    sms: {
      sourceType: '',
      user: '',
      hash: '',
      url: '',
      appKey: '',
      secretKey: '',
      password: '',
      account: '',
    },
    telegram: { token: '', chatId: '' },
    jpush: { appKey: '', masterSecret: '' },
    msgUse: '',
  };
}

export default {
  name: 'TenantMsgChannelPage',
  data() {
    return {
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filterChannelCode: null,
      kindOptions: [],
      dialogVisible: false,
      isEdit: false,
      isDetail: false,
      form: emptyForm(),
      formRules: {
        'jpush.appKey': [{ required: true, message: '请输入极光应用 AppKey', trigger: 'blur' }],
        'jpush.masterSecret': [{ required: true, message: '请输入极光应用 Master Secret', trigger: 'blur' }],
      },
    };
  },
  computed: {
    ...mapState(['userInfo']),
    /** 仅存对应按钮菜单权限；仅靠页面 view 不可改通道 */
    canChannelAdd() {
      return hasPerm(this.userInfo || {}, 'tenant:msg_push_channel:add');
    },
    canChannelEdit() {
      return hasPerm(this.userInfo || {}, 'tenant:msg_push_channel:edit');
    },
    canChannelDelete() {
      return hasPerm(this.userInfo || {}, 'tenant:msg_push_channel:delete');
    },
    canChannelView() {
      return hasPerm(this.userInfo || {}, 'tenant:msg_push_channel:view');
    },
    dialogTitle() {
      if (this.isDetail) return '消息通道详情';
      return this.isEdit ? '编辑消息通道' : '新增消息通道';
    },
  },
  created() {
    this.loadTypes();
    this.fetchList();
  },
  methods: {
    async loadTypes() {
      try {
        const res = await api.types();
        this.kindOptions = (res && res.data) || [];
      } catch (e) {
        /* empty */
      }
    },
    onFilterChannel() {
      this.page = 1;
      this.fetchList();
    },
    async fetchList() {
      try {
        const res = await api.page({
          page: this.page,
          size: this.pageSize,
          channelCode: this.filterChannelCode || undefined,
        });
        const pr = res && res.data ? res.data : {};
        this.rows = pr.items || [];
        this.total = pr.total || 0;
      } catch (e) {
        /* empty */
      }
    },
    onSizeChange(s) {
      this.pageSize = s;
      this.page = 1;
      this.fetchList();
    },
    formatMs(ms) {
      if (ms == null || ms === '') return '-';
      const n = Number(ms);
      if (Number.isNaN(n)) return '-';
      const d = new Date(n);
      const p = (x) => String(x).padStart(2, '0');
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(
        d.getSeconds(),
      )}`;
    },
    openCreate() {
      this.isDetail = false;
      this.isEdit = false;
      this.form = emptyForm();
      if (this.kindOptions.length) {
        this.form.channelCode = this.kindOptions[0].code;
      }
      this.dialogVisible = true;
    },
    async openEdit(row) {
      this.isDetail = false;
      this.isEdit = true;
      try {
        const res = await api.detail(row.id);
        const d = res && res.data ? res.data : {};
        this.form = Object.assign(emptyForm(), {
          id: d.id,
          channelCode: d.channelCode,
          solidity: 0,
          msgUse: d.msgUse || '',
          awsEmail: Object.assign(emptyForm().awsEmail, d.awsEmail || {}),
          lark: Object.assign(emptyForm().lark, d.lark || {}),
          myTask: Object.assign(emptyForm().myTask, d.myTask || {}),
          sms: Object.assign(emptyForm().sms, d.sms || {}),
          telegram: Object.assign(emptyForm().telegram, d.telegram || {}),
          jpush: Object.assign(emptyForm().jpush, d.jpush || {}),
        });
        this.dialogVisible = true;
      } catch (e) {
        /* empty */
      }
    },
    async openDetail(row) {
      this.isDetail = true;
      this.isEdit = true;
      try {
        const res = await api.detail(row.id);
        const d = res && res.data ? res.data : {};
        this.form = Object.assign(emptyForm(), {
          id: d.id,
          channelCode: d.channelCode,
          solidity: 0,
          msgUse: d.msgUse || '',
          awsEmail: Object.assign(emptyForm().awsEmail, d.awsEmail || {}),
          lark: Object.assign(emptyForm().lark, d.lark || {}),
          myTask: Object.assign(emptyForm().myTask, d.myTask || {}),
          sms: Object.assign(emptyForm().sms, d.sms || {}),
          telegram: Object.assign(emptyForm().telegram, d.telegram || {}),
          jpush: Object.assign(emptyForm().jpush, d.jpush || {}),
        });
        this.dialogVisible = true;
      } catch (e) {
        this.isDetail = false;
      }
    },
    resetForm() {
      this.isDetail = false;
      this.form = emptyForm();
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate();
      });
    },
    buildPayload() {
      return {
        id: this.form.id,
        channelCode: this.form.channelCode,
        solidity: 0,
        msgUse: this.form.msgUse,
        awsEmail: this.form.channelCode === 'AWS_EMAIL' ? this.form.awsEmail : null,
        lark: this.form.channelCode === 'LARK' ? this.form.lark : null,
        myTask: this.form.channelCode === 'MY_TASK' ? this.form.myTask : null,
        sms: this.form.channelCode === 'SMS' ? this.form.sms : null,
        telegram: this.form.channelCode === 'TELEGRAM' ? this.form.telegram : null,
        jpush: this.form.channelCode === 'JPUSH' ? this.form.jpush : null,
      };
    },
    confirmSubmit() {
      if (this.isDetail) return;
      if (!this.form.channelCode) {
        Message.warning('请选择通道名称');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        MessageBox.confirm('确认保存该消息通道配置？', '提示', {
          type: 'warning',
        })
          .then(() => this.doSubmit())
          .catch(() => {});
      });
    },
    async doSubmit() {
      try {
        const body = this.buildPayload();
        if (this.isEdit) {
          await api.update(body);
        } else {
          await api.save(body);
        }
        Message.success('保存成功');
        this.dialogVisible = false;
        this.fetchList();
      } catch (e) {
        /* empty */
      }
    },
    confirmDelete(row) {
      MessageBox.confirm('确认删除该通道？（逻辑删除）', '提示', { type: 'warning' })
        .then(async () => {
          await api.remove(row.id);
          Message.success('已删除');
          this.fetchList();
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.page-content {
  margin-top: 12px;
}
.toolbar {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.filter-channel {
  width: 220px;
}
.pager {
  margin-top: 16px;
  text-align: right;
}
.ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}
</style>
